import { useCallback, useMemo } from "react";

import env from "react-dotenv";
import { useApi } from "shared/services/api/useApi";

export const useAllocations = () => {
    const { getDataAsync, postData } = useApi();

    const getAllocationsSummary = useCallback(async (params) => {
        const payload = await getDataAsync("allocationsSummary", { params: params });
        return payload.json();
    }, [getDataAsync]);

    const getAllocationsDetail = useCallback(async (params) => {
        const payload = await getDataAsync("allocationsDetail", { params: params });
        return payload.json();
    }, [getDataAsync]);

    const getAllocationsEstimation = useCallback(async (params) => {
        const payload = await getDataAsync("allocationsEstimation", { params: params });
        return payload.json();
    }, [getDataAsync]);

    const getAllocationsUsersIds = useCallback(async (params) => {
        const payload = await getDataAsync("allocationsUsersIds", { params: params });
        return payload.json();
    }, [getDataAsync]);

    const saveAllocationsHours = useCallback(async (params) => {
        if (env.BESTWORK_REACT_ALLOCATIONS_ENABLE_SAVE.toLowerCase() === "true") {
            return postData("saveAllocationsHours", params);
        }
    }, [postData]);

    return useMemo(() => {
        return {
            getAllocationsSummary,
            getAllocationsDetail,
            getAllocationsEstimation,
            saveAllocationsHours,
            getAllocationsUsersIds,
        };
    }, [
        getAllocationsSummary,
        getAllocationsDetail,
        getAllocationsEstimation,
        saveAllocationsHours,
        getAllocationsUsersIds,
    ]);
};
